import React from 'react';
import Card from './Card';
import './RemovedCardsHistory.css';

/**
 * Display history of removed cards
 */
const RemovedCardsHistory = ({ removedCards = [] }) => {
  if (!removedCards || removedCards.length === 0) {
    return null;
  }

  // Show most recent first
  const recentCards = [...removedCards].reverse().slice(0, 10);

  return (
    <div className="removed-cards-history">
      <h3 className="history-title">🎱 Potted Balls</h3>
      <div className="history-list">
        {recentCards.map((entry, index) => (
          <div key={`${entry.card?.id}-${entry.timestamp}`} className="history-item">
            <div className="history-card-mini">
              <Card card={entry.card} size="normal" />
            </div>
            <span className="history-player">{entry.playerName}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RemovedCardsHistory;

